var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ar-popup"},[_c('div',{staticClass:"ar-popup-box"},[_c('div',{staticClass:"ar-popup-title ar-flex"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"ar-popup-content"},[_vm._t("content")],2),_vm._v(" "),_c('div',{staticClass:"ar-popup-footer"},[_vm._t("footer")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-9165cf46","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/anyUI/popup/popup.vue
// module id = null
// module chunks = 